
import Ajax from "./AJAX.jsx";

export const performAjaxRequest = function(url, method, params, callback, paramsIsFile)
{
	const onComplete = function(response)
	{
	    //console.log("Response:");
	    //console.log(response);
	    var responseObj = null;

	    try{
	       
	       //Check if there is a leading waarning message emitted from php
	       const indexOfOpenBracket = response.indexOf("{");

	       if(indexOfOpenBracket != 0)
	       {
	          const warningMsg =  response.substring(0, indexOfOpenBracket);
	          responseObj = JSON.parse(response.substring(indexOfOpenBracket));
	          responseObj.error.push("php emitted warning as html in response: " + warningMsg);
	          responseObj.success = false;
	       }
	       else
	       {
	          responseObj = JSON.parse(response);
	       }
	       /*
	       console.log("ResponseObject:");
	       console.log(responseObj);
	       console.log("Response: " + response);
	       */
	    }
	    catch(e)
	    {
	       responseObj = new Object();
	       responseObj.success = false;
	       responseObj.error =['Could not parse response as json: ' + response];
	    }

	    if(responseObj == null)
	    {
	       responseObj = new Object();
	       responseObj.success = false;
	       responseObj.error =['Received null response from ajax call'];
	    }
	    

	    //Call callback if no rediretion has occured
	    callback(responseObj);

	}

	Ajax.performRequest(url, method, params, onComplete, paramsIsFile);
}.bind(this);



// WEBPACK FOOTER //
// ./js/networkTools.jsx